var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58 58",
    style: {
      enableBackground: "new 0 0 58 58"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 13.5,
    style: {
      fill: "#71C285"
    },
    width: 48,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M58,38.5H8v-26h50V38.5z M10,36.5h46v-22H10V36.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M9,5.5H4c-0.552,0-1-0.447-1-1s0.448-1,1-1h5c0.552,0,1,0.447,1,1S9.552,5.5,9,5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M9,14.5c-0.552,0-1-0.447-1-1v-9c0-0.553,0.448-1,1-1s1,0.447,1,1v9C10,14.053,9.552,14.5,9,14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M9,48.5c-0.552,0-1-0.447-1-1v-10c0-0.553,0.448-1,1-1s1,0.447,1,1v10C10,48.053,9.552,48.5,9,48.5z "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#556080"
    },
    cx: 19,
    cy: 52.5,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#556080"
    },
    cx: 43,
    cy: 52.5,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M52,48.5H9c-0.552,0-1-0.447-1-1s0.448-1,1-1h43c0.553,0,1,0.447,1,1S52.553,48.5,52,48.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E64C3C"
    },
    cx: 3,
    cy: 4.5,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 30,
    cy: 19.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 33,
    cy: 16.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 33,
    cy: 22.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 36,
    cy: 19.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 24,
    cy: 19.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 27,
    cy: 16.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 27,
    cy: 22.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 12,
    cy: 19.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 18,
    cy: 19.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 15,
    cy: 16.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 21,
    cy: 16.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 15,
    cy: 22.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 21,
    cy: 22.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 54,
    cy: 19.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 39,
    cy: 16.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 39,
    cy: 22.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 42,
    cy: 19.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 48,
    cy: 19.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 30,
    cy: 25.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 36,
    cy: 25.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 24,
    cy: 25.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 12,
    cy: 25.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 18,
    cy: 25.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 54,
    cy: 25.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 42,
    cy: 25.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 48,
    cy: 25.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 45,
    cy: 16.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 51,
    cy: 16.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 45,
    cy: 22.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 51,
    cy: 22.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 30,
    cy: 31.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 33,
    cy: 28.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 33,
    cy: 34.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 36,
    cy: 31.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 24,
    cy: 31.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 27,
    cy: 28.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 27,
    cy: 34.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 12,
    cy: 31.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 18,
    cy: 31.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 15,
    cy: 28.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 21,
    cy: 28.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 15,
    cy: 34.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 21,
    cy: 34.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 54,
    cy: 31.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 39,
    cy: 28.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 39,
    cy: 34.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 42,
    cy: 31.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 48,
    cy: 31.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 45,
    cy: 28.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 51,
    cy: 28.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 45,
    cy: 34.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4E869"
    },
    cx: 51,
    cy: 34.5,
    r: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartSvg);
export default __webpack_public_path__ + "static/media/CartSVG.473b320489a7f8004534c3fc415b6608.svg";
export { ForwardRef as ReactComponent };